import React from 'react';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { usePrice } from '../../../../../hooks';
import { useShouldUseMobileSettings } from '../../../../../hooks/useShouldUseMobileSettings';
import { classes as commonClasses } from '../../../../../styles/common.st.css';
import { st, classes } from './Price.st.css';

export interface PriceProps {
  price?: { value?: string; currency?: string };
  highlighted: boolean;
}

export const Price: React.FC<PriceProps> = ({ price: money, highlighted }) => {
  const { isMobile } = useEnvironment();
  const { price, currency } = usePrice({
    value: money?.value,
    currency: money?.currency,
    hideTrailingFractionZeroes: true,
  });
  const useMobileSettings = useShouldUseMobileSettings();

  return (
    <div
      data-hook={VIEWER_HOOKS.PLAN_PRICE}
      className={st(classes.wrapper, { highlighted, mobile: isMobile, useMobileSettings })}
    >
      <span aria-hidden="true" data-hook={VIEWER_HOOKS.PRICE_CURRENCY} className={classes.currency}>
        {currency}
      </span>
      <span aria-hidden="true" data-hook={VIEWER_HOOKS.PRICE_AMOUNT} className={classes.price}>
        {price}
      </span>
      <span data-hook={VIEWER_HOOKS.PLAN_PRICE_SCREEN_READER} className={commonClasses.srOnly}>
        {price + currency}
      </span>
    </div>
  );
};
